import React, { useState } from "react";
import Step4 from "./steps/Step4";
import Step3 from "./steps/Step3";
import Step2 from "./steps/Step2";
import Step1 from "./steps/Step1";
import styles from './Form.module.css'

function Form({ sendResult }) {
  const [page, setPage] = useState(0);
  const [nextButtonState, setNextButtonState] = useState(false);
  const [formData, setFormData] = useState({
    ageInterval: '',
    grade: '',
    difficultMaterial: '',
    mostEnjoyableMaterial: '',
    leastEnjoyableMaterial: '',


    preferedLangage: '',

    wasEdTechUser: null,
    usageTarget: '',
    examPrepPractice: '',
    remembersPeopleBy: '',


    sleepHours: '',
    presenceAttentionInClassLast10Days: '',
    stateWhileAskingQuestions: '',


    name: "Anonymous Student",
    phone: '',



  });




  /*
    id:auth.currentUser.uid,
    name:auth.currentUser.displayName,
    phone:(enteredPhone || auth.currentUser.phoneNumber ),
    age:enteredAge,
    prefered_language:enteredLang,
    grade:enteredGrade,
    expiry_date: new Timestamp(nextMonth,0),*/

  const FormsTotalNumber = 4;

  const PageDisplay = () => {

    switch (page) {
      case 0:
        return <Step1 formData={formData}
          setFormData={setFormData}
          setNextButtonState={setNextButtonState} />

      case 1:
        return <Step2 formData={formData}
          setFormData={setFormData}
          setNextButtonState={setNextButtonState} />

      case 2:
        return <Step3 formData={formData}
          setFormData={setFormData}
          setNextButtonState={setNextButtonState} />

      case 3:
        return <Step4 formData={formData}
          setFormData={setFormData}
          setNextButtonState={setNextButtonState} />

      default:
        return;

    }

  };

  return (
    <div className={styles.form}>

      <div className={styles.formContainer}>
        <div className={styles.progressbar}>
          <div
            style={{ width: ((page + 1) * (100 / FormsTotalNumber)).toString() + "%" }}
          ></div>
        </div>

        <div className={styles.controlHeader}>
          <button
            className={styles.backButton}
            disabled={page == 0}
            onClick={() => {
              setPage((currPage) => currPage - 1);
            }}
          >
            Back
          </button>

          <b>{(page + 1) + ' of ' + FormsTotalNumber}</b>
          <button
            className={styles.nextButton}
            disabled={!nextButtonState}
            onClick={() => {
              if (page === FormsTotalNumber - 1) {
                sendResult(formData)

              } else {
                setPage((currPage) => currPage + 1);
              }
            }}
          ><>
              {page === FormsTotalNumber - 1 ? "Submit" : "Next"}</>
          </button>
        </div>

        <div className={styles.body}>{PageDisplay()}</div>

      </div>
    </div>
  );
}

export default Form;
